import { RegionCardProps } from './RegionCard'
import RegionCardsCarousel, {
  RegionCardLayoutType
} from './RegionCardsCarousel'

export default RegionCardsCarousel
export { RegionCardLayoutType }
export type { RegionCardProps }
